import GoogleSvg from '../../../../assets/icons/google.svg';
import type { ProviderIconComponent } from '../../types';

const GoogleIcon: ProviderIconComponent = ({ size = 24 }) => (
  <span
    style={{
      width: size,
      height: size,
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <GoogleSvg style={{ width: '100%', height: '100%' }} />
  </span>
);

export default GoogleIcon;
